import { match } from 'ts-pattern';
import { Pill, type PillProps, type PillVariant } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import { IxcSweepsClearingV1OrderType } from '@interxfi/types/generated/api';

interface SweepOrderTypePillProps extends Omit<PillProps, 'children' | 'variant'> {
  orderType: IxcSweepsClearingV1OrderType | undefined;
}

export function SweepOrderTypePill({ isPending, orderType, ...props }: SweepOrderTypePillProps) {
  return (
    <Pill
      isPending={!orderType || isPending}
      {...props}
      variant={match(orderType)
        .returnType<PillVariant>()
        .with(IxcSweepsClearingV1OrderType.Purchase, () => 'green')
        .with(IxcSweepsClearingV1OrderType.Redeem, () => 'danger')
        .otherwise(() => 'neutral')}
    >
      <TranslatedText
        defaultValue={orderType}
        i18nKey={{ namespace: 'ixcSweepsClearingV1', enumName: 'IxcSweepsClearingV1OrderType', value: orderType }}
      />
    </Pill>
  );
}
